import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Antd from 'ant-design-vue'
import { message } from 'ant-design-vue'
import store from './store'
import * as filters from '@/utils/filter.js'
import Print from 'vue-print-nb'
import './assets/styles/base.less'
import '@/assets/fonts/iconfont.css'
// import qs from 'qs'
import 'ant-design-vue/dist/antd.css';
import '@/api/api.js'
import moment from 'moment'; 
import 'moment/locale/zh-cn'
import {convertCurrency} from '@/utils/bigMoney.js'
import VueContextMenu from 'vue-contextmenu'
import { sha256 } from 'js-sha256'
import '@/utils/rem.js'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

moment.locale('zh-cn')
Vue.config.productionTip = false
Vue.prototype.$message = message
Vue.prototype.$moment = moment
Vue.prototype.$convertCurrency = convertCurrency
Vue.prototype.$sha256 = sha256
Vue.use(Print)
Vue.use(VueContextMenu)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.use(filters);
Vue.use(Antd)
Vue.use(Viewer)
Vue.prototype.$store = store
Viewer.setDefaults({
  Options:{
    'inline':true,
    'button':true,
    'navbar':true,
    'title':true,
    'toolbar':true,
    'tooltip':true,
    'movable':true,
    'zoomable':true,
    'rotatable':true,
    'scalable':true,
    'transition':true,
    'fullscreen':true,
    'keyboard':true,
    'url':'src'
  }
})
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
